import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Box,
  useMediaQuery,
} from "@mui/material";
//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Navbar + Logout---------------- 
import HorizontalNavbar from "./HorizontalNavbar";
import MobileBottomNav from "./MobileBottomNav";
import Logout from "./Logout";
import ProtectedRoute from "./components/common/ProtectedRoute";

//---------------- PWA Components---------------- 
import PWAStatus from "./components/common/PWAStatus";

//---------------- Service Worker Registration---------------- 
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import LodingComponent from "./loding";
// import Loginlogo from "./Loginlogo.png";

//-----------SessionTimeOut---------
import SessionTimeout from "./SessionTimeout";

//-----------Company----------------
import CompanyEdit from "./components/pages/Company/Edit";

//-----------Home-------------------
import Home from "./components/pages/Home";
//-----------Role-------------------
// import RoleIndex from "./components/pages/Role/Index";
// import RoleDetail from "./components/pages/Role/Detail";

//-----------User-------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//-----------Product-------------------
// import ProductCategoryIndex from "./components/pages/ProductCategory/Index";
// import ProductItemIndex from "./components/pages/ProductItem/Index";
// import ProductBrandIndex from "./components/pages/ProductBrand/Index";
// import ProductRelationIndex from "./components/pages/ProductRelation/Index";

//-----------Bank-------------------
import BankIndex from "./components/pages/Bank/Index";

//-----------Master-------------------
// import MasterDashboard from "./components/pages/Master/MasterDashboard";
// import ClientIndex from "./components/pages/Master/ClientIndex";
// import VendorIndex from "./components/pages/Master/VendorIndex";

//-----------Board-------------------
import BoardIndex from "./components/pages/Board/Index";

//-----------Frame-------------------
import FrameIndex from "./components/pages/Frame/Index";

//-----------Glass-------------------
import GlassIndex from "./components/pages/Glass/Index";

//-----------Hook-------------------
import HookIndex from "./components/pages/Hook/Index";

//-----------Item-------------------
import ItemIndex from "./components/pages/Item/Index";

//-----------Lamination-------------------
import LaminationIndex from "./components/pages/Lamination/Index";

//-----------Mount-------------------
import MountIndex from "./components/pages/Mount/Index";

//-----------Print-------------------
import PrintIndex from "./components/pages/Print/Index";

//-----------Size-------------------
import SizeIndex from "./components/pages/Size/Index";

//-----------Stand-------------------
import StandIndex from "./components/pages/Stand/Index";

//-----------Tape-------------------
import TapeIndex from "./components/pages/Tape/Index";

//-----------Master-------------------
import MasterIndex from "./components/pages/Master/Index";

//-----------Estimate-------------------
import EstimateIndex from "./components/pages/Estimate/EstimateIndex";

//-----------Bill-------------------
import BillIndex from "./components/pages/Bill/BillIndex";

//-----------AccountHead-------------------
import AccHeadIndex from "./components/pages/AccountHead/AccHeadIndex";

//-----------PurchaseOrder-------------------
// import PurchaseOrderIndex from "./components/pages/PurchaseOrder/PurchaseOrderIndex";

//-----------Purchase-------------------
import PurchaseIndex from "./components/pages/Purchase/PurchaseIndex";

//-----------PurchaseReturn-------------------
// import PurchaseReturnAgainstIndex from "./components/pages/PurchaseReturn/PurchaseReturnAgainstIndex";

//-----------Quotation-------------------
// import QuotationIndex from "./components/pages/Quotation/QuotationIndex";

//-----------SalesOrder-------------------
// import SalesOrderIndex from "./components/pages/SaleOrder/SalesOrderIndex";
 
//---- -------Sale-------------------
// import SaleIndex from "./components/pages/Sale/SaleIndex";

//-----------SaleReturn-------------------
// import SaleReturnIndex from "./components/pages/SaleReturn/SaleReturnIndex";

//-----------Stock-------------------
// import StockTransferInIndex from "./components/pages/Stock/StockTransferInIndex";
// import StockTransferOutIndex from "./components/pages/Stock/StockTransferOutIndex";

//-----------PaymentReceipts-------------------
import PaymentReceiptsIndex from "./components/pages/PaymentReceipts/PaymentReceiptsIndex";

//-----------PettyCash-------------------
import PettyCashIndex from "./components/pages/PettyCash/PettyCashIndex";

//-----------CreditDebit-------------------
import CreditDebitIndex from "./components/pages/CreditDebit/CreditDebitIndex";

//-----------JournalEntry-------------------
// import JournalEntryIndex from "./components/pages/JournalEntry/JournalEntryIndex";

//-----------Reports-------------------
import WorkOrderReport from "./components/pages/Reports/WorkOrderReport";
import WorkOrderItemsReport from "./components/pages/Reports/WorkOrderItemsReport";
import BillStatementReport from "./components/pages/Reports/BillStatementReport";
import LedgerReport from "./components/pages/Reports/LedgerReport";
import CashBookReport from "./components/pages/Reports/CashBookReport";
import DebtorsListReport from "./components/pages/Reports/DebtorsListReport";
import CreditorsListReport from "./components/pages/Reports/CreditorsListReport";
import TrialBalanceReport from "./components/pages/Reports/TrialBalanceReport";
import PettyCashReport from "./components/pages/Reports/PettyCashReport";

//-----------Admin Reports-------------------
import AdminLedgerReport from "./components/pages/AdminReports/AdminLedgerReport";
import AdminCashBookReport from "./components/pages/AdminReports/AdminCashBookReport";
import AdminDebtorsListReport from "./components/pages/AdminReports/AdminDebtorsListReport";
import AdminCreditorsListReport from "./components/pages/AdminReports/AdminCreditorsListReport";
import AdminTrialBalanceReport from "./components/pages/AdminReports/AdminTrialBalanceReport";
// import {PurchaseReport, PurchaseOrderStatusReport, VendorandItemWisePurchaseReport, 
//   VendorAgeingReport, SaleReport, CustomerandItemWiseSaleReport, CustomerAgeingReport,
//   SaleOrderStatusReport, SaleGstReport, StockTransferReport } from "./components/pages/Reports";

// import CashBook from "./components/pages/Reports/CashBook";
// import ReportsHub from "./components/pages/Reports/ReportsHub";

//-----------EInvoice-------------------
// import EInvoiceIndex from "./components/pages/EInvoice/EInvoiceIndex";


// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    primary: { main: '#5c3d1e' },      // fc-wood
    secondary: { main: '#c9a84c' },    // fc-gold
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: '8px', textTransform: 'none' },
      },
    },
  },
});

//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const { companyName, roleName, username, isAuthenticated } = useAuth();
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Session Timeout Component - only render when authenticated */}
        {isAuthenticated && <SessionTimeout />}

        {/* PWA Status Component */}
        <PWAStatus
          showInstallPrompt={true}
          showUpdatePrompt={true}
          showOfflineStatus={true}
        />

        {/* Header with integrated menu */}
        <AppBar position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1, background: 'linear-gradient(135deg, #3b2410 0%, #5c3d1e 60%, #7a5230 100%)', borderBottom: '2px solid #c9a84c' }}>
          <Toolbar sx={{ minHeight: '48px !important', height: '48px', px: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', textTransform: 'uppercase', mr: 2 }}>
              <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit' }}>
                <span style={{ fontFamily: 'Georgia, serif', fontSize: '14px', letterSpacing: '2px', background: 'linear-gradient(90deg, #e8c97a, #c9a84c, #f5dfa0)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                  🖼️ {companyName}
                </span>
              </Link>
            </Typography>
            {!isMobile && username !== "Counter" && <HorizontalNavbar />}
            <Box sx={{ flexGrow: 1 }} />
            <Logout />
          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box
          sx={{
            pt: '48px',
            pb: isMobile ? '70px' : 0,
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            backgroundColor: '#fdf6ec',   // fc-cream
          }}
        >
          <Box sx={{ p: 0, flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />

              {/* Role */}
              {/* <Route path="/RoleIndex" component={RoleIndex} /> */}
              {/* <Route path="/RoleDetail/:id" component={RoleDetail} /> */}

              {/* User */}
              <ProtectedRoute path="/UserIndex" component={UserIndex} requiredPermission="UserRead Administration" />
              <ProtectedRoute path="/UserCreate" component={UserCreate} requiredPermission="UserRead Administration" />
              <ProtectedRoute path="/UserEdit/:id" component={UserEdit} requiredPermission="UserRead Administration" />
              <ProtectedRoute path="/UserDetail/:id" component={UserDetail} requiredPermission="UserRead Administration" />
              <ProtectedRoute path="/PasswordChange" component={PasswordChange} />

              {/* Client */}
              {/* <Route path="/ClientIndex" component={ClientIndex} /> */}

              {/* Vendor */}
              {/* <Route path="/VendorIndex" component={VendorIndex} /> */}

              {/* Product */}
              {/* <Route path="/ProductCategoryIndex" component={ProductCategoryIndex} /> */}
              {/* <Route path="/ProductItemIndex" component={ProductItemIndex} /> */}
              {/* <Route path="/ProductBrandIndex" component={ProductBrandIndex} /> */}
              {/* <Route path="/ProductRelationIndex" component={ProductRelationIndex} /> */}

              {/* Bank */}
              <ProtectedRoute path="/BankIndex" component={BankIndex} requiredPermission="UserRead Accounts" />

              {/* Master */}
              {/* <Route path="/MasterDashboard" component={MasterDashboard} /> */}
              {/* <Route path="/ClientIndex" component={ClientIndex} /> */}
              {/* <Route path="/VendorIndex" component={VendorIndex} /> */}

              {/* AccountHead */}
              {/* <Route path="/AccountHeadDashboard" component={AccountHeadDashboard} /> */}
              {/* <Route path="/AccountHeadIndex" component={AccountHeadIndex} /> */}
              {/* <Route path="/AssetIndex" component={AssetIndex} /> */}
              {/* <Route path="/CapitalIndex" component={CapitalIndex} /> */}
              {/* <Route path="/OtherOptionIndex" component={OtherOptionIndex} /> */}
              {/* <Route path="/SalesExecutiveIndex" component={SalesExecutiveIndex} /> */}
              {/* <Route path="/BalanceSheetHeadIndex" component={BalanceSheetHeadIndex} /> */}

              {/* PurchaseOrder */}
              {/* <Route path="/PurchaseOrderIndex" component={PurchaseOrderIndex} /> */}

              {/* Purchase */}
              <ProtectedRoute path="/PurchaseIndex" component={PurchaseIndex} requiredPermission="UserRead Transaction" />

              {/* PurchaseReturn */}
              {/* <Route path="/PurchaseReturnAgainstIndex" component={PurchaseReturnAgainstIndex} /> */}

              {/* Quotation */}
              {/* <Route path="/QuotationIndex" component={QuotationIndex} /> */}

              {/* SalesOrder */}
              {/* <Route path="/SaleOrderIndex" component={SalesOrderIndex} /> */}

              {/* Sale */}
              {/* <Route path="/SaleIndex" component={SaleIndex} /> */}

              {/* SaleReturn */}
              {/* <Route path="/SalesReturnIndex" component={SaleReturnIndex} /> */}

              {/* Stock */}
              {/* <Route path="/StockTransferInIndex" component={StockTransferInIndex} /> */}
              {/* <Route path="/StockTransferOutIndex" component={StockTransferOutIndex} /> */}

              {/* PaymentReceipts */}
              <ProtectedRoute path="/PaymentAndReceiptIndex" component={PaymentReceiptsIndex} requiredPermission="UserRead Accounts" />

              {/* PettyCash */}
              <ProtectedRoute path="/PettyCashIndex" component={PettyCashIndex} requiredPermission="UserRead Accounts" />

              {/* CreditDebit */}
              <ProtectedRoute path="/CreditDebitIndex" component={CreditDebitIndex} requiredPermission="UserRead Accounts" />

              {/* JournalEntry */}
              {/* <Route path="/JournalEntryIndex" component={JournalEntryIndex} /> */}

              {/* Reports */}
              <ProtectedRoute path="/WorkOrderReport" component={WorkOrderReport} requiredPermission="UserRead Reports" />
              <ProtectedRoute path="/WorkOrderItemsReport" component={WorkOrderItemsReport} requiredPermission="UserRead Reports" />
              <ProtectedRoute path="/BillStatementReport" component={BillStatementReport} requiredPermission="UserRead Reports" />
              {/* <Route path="/ReportsHub" component={ReportsHub} /> */}
              <ProtectedRoute path="/Ledger" component={LedgerReport} requiredPermission="UserRead Reports" />
              <ProtectedRoute path="/CashBook" component={CashBookReport} requiredPermission="UserRead Reports" />
              <ProtectedRoute path="/DebtorsList" component={DebtorsListReport} requiredPermission="UserRead Reports" />
              <ProtectedRoute path="/CreditorsList" component={CreditorsListReport} requiredPermission="UserRead Reports" />
              <ProtectedRoute path="/TrialBalance" component={TrialBalanceReport} requiredPermission="UserRead Reports" />
              <ProtectedRoute path="/PettyCashReport" component={PettyCashReport} requiredPermission="UserRead Reports" />

              {/* Admin Reports */}
              <ProtectedRoute path="/AdminLedger" component={AdminLedgerReport} requiredPermission="UserRead AdminReports" />
              <ProtectedRoute path="/AdminCashBook" component={AdminCashBookReport} requiredPermission="UserRead AdminReports" />
              <ProtectedRoute path="/AdminDebtorsList" component={AdminDebtorsListReport} requiredPermission="UserRead AdminReports" />
              <ProtectedRoute path="/AdminCreditorsList" component={AdminCreditorsListReport} requiredPermission="UserRead AdminReports" />
              <ProtectedRoute path="/AdminTrialBalance" component={AdminTrialBalanceReport} requiredPermission="UserRead AdminReports" />

              {/* <Route path="/PurchaseReport" component={PurchaseReport} /> */}
              {/* <Route path="/PurchaseOrderStatusReport" component={PurchaseOrderStatusReport} /> */}
              {/* <Route path="/VendorAgeingReport" component={VendorAgeingReport} /> */}
              {/* <Route path="/VendorandItemWisePurchaseReport" component={VendorandItemWisePurchaseReport} /> */}
              {/* <Route path="/SalesReport" component={SaleReport} /> */}
              {/* <Route path="/CustomerWiseSalesReport" component={CustomerandItemWiseSaleReport} /> */}
              {/* <Route path="/CustomerAgeingReport" component={CustomerAgeingReport} /> */}
              {/* <Route path="/SalesOrderReport" component={SaleOrderStatusReport} /> */}
              {/* <Route path="/CashBook" component={CashBook} /> */}
              {/* <Route path="/SaleGstReport" component={SaleGstReport} /> */}
              {/* <Route path="/StockTransferReport" component={StockTransferReport} /> */}

              {/* EInvoice */}
              {/* <Route path="/EInvoiceIndex" component={EInvoiceIndex} /> */}

              {/* Company */}
              <ProtectedRoute path="/CompanyEdit" component={CompanyEdit} requiredPermission="UserRead Master" />

              {/* Board / Frame Board */}
              <ProtectedRoute path="/BoardIndex" component={BoardIndex} requiredPermission="UserRead Master" />

              {/* Frame */}
              <ProtectedRoute path="/FrameIndex" component={FrameIndex} requiredPermission="UserRead Master" />

              {/* Glass */}
              <ProtectedRoute path="/GlassIndex" component={GlassIndex} requiredPermission="UserRead Master" />

              {/* Hook */}
              <ProtectedRoute path="/HookIndex" component={HookIndex} requiredPermission="UserRead Master" />

              {/* Item */}
              <ProtectedRoute path="/ItemIndex" component={ItemIndex} requiredPermission="UserRead Master" />

              {/* Lamination */}
              <ProtectedRoute path="/LaminationIndex" component={LaminationIndex} requiredPermission="UserRead Master" />

              {/* Mount */}
              <ProtectedRoute path="/MountIndex" component={MountIndex} requiredPermission="UserRead Master" />

              {/* Print */}
              <ProtectedRoute path="/PrintIndex" component={PrintIndex} requiredPermission="UserRead Master" />

              {/* Size */}
              <ProtectedRoute path="/SizeIndex" component={SizeIndex} requiredPermission="UserRead Master" />

              {/* Stand */}
              <ProtectedRoute path="/StandIndex" component={StandIndex} requiredPermission="UserRead Master" />

              {/* Tape */}
              <ProtectedRoute path="/TapeIndex" component={TapeIndex} requiredPermission="UserRead Master" />

              {/* Master */}
              <ProtectedRoute path="/MasterIndex" component={MasterIndex} requiredPermission="UserRead Master" />

              {/* Estimate */}
              <ProtectedRoute path="/EstimateIndex" component={EstimateIndex} requiredPermission="UserRead Transaction" />

              {/* Bill */}
              <ProtectedRoute path="/BillIndex" component={BillIndex} requiredPermission="UserRead Transaction" />

              {/* AccountHead */}
              <ProtectedRoute path="/AccHeadIndex" component={AccHeadIndex} requiredPermission="UserRead Accounts" />

            </Switch>
          </Box>
        </Box>

        {/* Mobile Bottom Navigation */}
        {isMobile && username !== "Counter" && <MobileBottomNav />}
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  useEffect(() => {
    // Register service worker with enhanced features
    serviceWorkerRegistration.register({
      onSuccess: (registration) => {
        console.log('SW registered successfully');
      },
      onUpdate: (registration) => {
        console.log('SW update available');
      }
    });

    // Handle PWA install prompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      window.deferredPrompt = e;
    };

    const handleAppInstalled = () => {
      console.log('PWA was installed');
      window.deferredPrompt = null;
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
